import React, { FC, useId } from 'react'
import {
  TrustPoints,
  WHY_TRUST_RECOVERY_DESCRIPTION,
  WHY_TRUST_RECOVERY_TITLE
} from './WhyTrustRecovery'
import { ChevronDown } from 'react-bootstrap-icons'
import IconRecoverySealSeafoam from '../icons/IconRecoverySeal/IconRecoverySealSeafoam'
import IconRecoverySealWhite from '../icons/IconRecoverySeal/IconRecoverySealWhite'
import { isNonEmptyString } from '@/utils/checks'
import useSegment from '../../hooks/segment/useSegment'

const WhyTrustRecoveryMobile: FC = ({
  insuranceSlug
}: {
  insuranceSlug: string
}) => {
  const segment = useSegment()
  const id = `why-trust-recovery-mobile-${useId()}`
  const shouldUseInsuranceLayout = isNonEmptyString(insuranceSlug)

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const page = window.location.pathname
      const platform = 'mobile'

      const eventData = {
        page: page,
        platform: platform
      }
      segment.trustBlock.click(eventData)
    }
  }

  return (
    <div
      className={`group flex flex-col rounded-2xl border ${
        shouldUseInsuranceLayout
          ? 'border-white/25 bg-white/55 active:bg-white/60'
          : 'border-seafoam-150 bg-seafoam-25 active:bg-seafoam-50'
      }`}
    >
      <input
        type="checkbox"
        className="hidden"
        id={id}
        onChange={handleOnChange}
      />
      {!shouldUseInsuranceLayout && (
        <label
          className="flex cursor-pointer items-center justify-between p-4"
          htmlFor={id}
        >
          <div className="flex items-center gap-4">
            <IconRecoverySealSeafoam className="size-10" />
            <h2 className="text-base font-medium text-gray-1100">
              {WHY_TRUST_RECOVERY_TITLE}
            </h2>
          </div>
          <ChevronDown className={`size-4 group-has-[:checked]:rotate-180`} />
        </label>
      )}
      {shouldUseInsuranceLayout && (
        <label
          className="flex cursor-pointer items-center justify-between p-4"
          htmlFor={id}
        >
          <div className="flex items-center gap-4">
            <IconRecoverySealWhite
              className="size-10"
              insuranceSlug={insuranceSlug}
            />
            <h2 className="text-base font-medium text-gray-1100">
              {WHY_TRUST_RECOVERY_TITLE}
            </h2>
          </div>
          <ChevronDown className={`size-4 group-has-[:checked]:rotate-180`} />
        </label>
      )}
      <div className="hidden flex-col gap-6 px-4 pb-4 group-has-[:checked]:flex">
        <div className="flex flex-col gap-2">
          <p
            className="text-sm text-gray-800"
            dangerouslySetInnerHTML={{ __html: WHY_TRUST_RECOVERY_DESCRIPTION }}
          ></p>
        </div>
        <TrustPoints
          checksBgColor={
            shouldUseInsuranceLayout
              ? `bg-insurance-bg-${insuranceSlug}`
              : 'bg-seafoam-150'
          }
        />
      </div>
    </div>
  )
}

export default WhyTrustRecoveryMobile
